import { onMounted, onUnmounted } from 'vue'
const useModal = () => {
  const backdropElementId = 'modal-backdrop'
  const backdropElementIdSelector = `#${backdropElementId}`
  const modalOpenClassName = 'modal-open'

  const addModalBackdrop = () => {
    let elModalBackdrop = document.querySelector(backdropElementIdSelector)

    if (elModalBackdrop === null) {
      elModalBackdrop = document.createElement('div')
      elModalBackdrop.id = backdropElementId
      elModalBackdrop.classList.add('modal-backdrop')
      elModalBackdrop.classList.add('opacity-50')

      document.body.append(elModalBackdrop)
      document.body.classList.add(modalOpenClassName)
      document.body.style.overflow = 'hidden'
    }
  }

  const removeModalBackdrop = () => {
    // Runs after this modal's element has left the DOM, so it never counts itself.
    // The backdrop is shared with other `useModal` modals; the page lock also with the cart config modal.
    if (document.querySelectorAll('.modal.show').length > 0) {
      return
    }

    document.querySelector(backdropElementIdSelector)?.remove()

    if (document.querySelectorAll('.cart-config-modal').length === 0) {
      document.body.classList.remove(modalOpenClassName)
      document.body.style.overflow = ''
    }
  }

  onMounted(() => {
    addModalBackdrop()
  })
  onUnmounted(() => {
    removeModalBackdrop()
  })
}

export default useModal
